import { render, staticRenderFns } from "./sidebar.html?vue&type=template&id=015c5a45&scoped=true&external"
import script from "./sidebar.js?vue&type=script&lang=js&external"
export * from "./sidebar.js?vue&type=script&lang=js&external"
import style0 from "./sidebar.scss?vue&type=style&index=0&id=015c5a45&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c5a45",
  null
  
)

export default component.exports